import {
  SlackMessageParams,
  SlackRecipientEmail
} from '@dadohr/shared/domainTypes/integrations/slack';
import { CF } from '@dadohr/shared/versions';
import { callFirebaseFunction } from '../firebaseFunctions';

export const sendPreviewSlackMessage = (
  params: SlackMessageParams,
  recipient: SlackRecipientEmail,
  isChannelPreview: boolean
) => {
  return callFirebaseFunction(CF.slack.sendPreviewMesage, {
    params,
    recipient,
    isChannelPreview
  });
};
